module.exports = __webpack_public_path__ + "img/handicrafts.ac6e84cd.svg";